import { render, staticRenderFns } from "./UpdatePerson.vue?vue&type=template&id=001521c2&scoped=true"
import script from "./UpdatePerson.vue?vue&type=script&lang=js"
export * from "./UpdatePerson.vue?vue&type=script&lang=js"
import style0 from "./UpdatePerson.vue?vue&type=style&index=0&id=001521c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "001521c2",
  null
  
)

export default component.exports